/**
 * PROPS
 *
 * marginTop => margin top component | default 0px | string
 * marginBottom => margin bottom component | default 0px | string
 */

import React from "react";
import PropTypes from "prop-types";
import Vars from "Consts/vars";

const TermsAndConditionsTicketDesktop = (props) => {

	const {
		marginTop,
		marginBottom,
	} = props;
	return (
		<>
			<div className="tac-container">
				{
					Vars.TERMS_AND_CONDITION.map((item) => (
						<div className="tac-box" key={item.id}>
							<h2 className="tac-box__title">{item.title}</h2>
							<ul className="tac-box__list">
								{
									item.content.length > 0 && item.content.map((point) => (
										<li className="tac-box__text" key={point}>
											{point}
										</li>
									))
								}
							</ul>
						</div>
					))
				}
			</div>

			<style jsx>{`
        .tac-container {
          position: relative;
          width: 100%;
          height: auto;
          align-text: center;
          margin: ${marginTop} 0 ${marginBottom} 0;
          padding: 0;
        }
        .tac-box {
					width: 100%;
          max-width: 934px;
          height: auto;
          margin: 0 auto;
        }
				.tac-box + .tac-box {
					margin-top: 80px;
				}
        .tac-box__title {
          font-family: 'Poppins';
          font-style: normal;
          font-weight: 600;
          font-size: 20px;
          line-height: 28px;
          text-transform: capitalize;
          color: #000000;
          margin: 0;
        }
        .tac-box__list {
          margin: 24px 0 0 0;
          padding: 0 0 0 17px;
        }
        .tac-box__text {
          list-style-position: outside;
          list-style-type: decimal;
          font-family: 'Roboto';
          font-style: normal;
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          color: #13161A;
        }
      `}
			</style>
		</>
	);

};

TermsAndConditionsTicketDesktop.propTypes = {
	marginTop: PropTypes.string,
	marginBottom: PropTypes.string,
};

TermsAndConditionsTicketDesktop.defaultProps = {
	marginTop: "0px",
	marginBottom: "0px",
};

export default TermsAndConditionsTicketDesktop;
